import { useCallback, useEffect, useState } from 'react';
import { getAllGameEvents } from 'services/api/gameEventsApi';
import { GameEvent } from 'types/components/GameEvent';

import { FiltersType } from '../types/filtersType';

const useGameEvents = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<GameEvent[]>([]);
  const [dateSort, setDateSort] = useState<'asc' | 'desc'>('desc');
  const [filters, setFilters] = useState<FiltersType[]>([
    {
      field: 'published',
      operator: '==',
      value: true,
    },
  ]);

  const fetch = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);
    const data = await getAllGameEvents({ dateSort, filters });
    setData(data);
    setIsLoading(false);
  }, [setIsLoading, setData, dateSort, filters, isLoading]);

  const toggleDateSort = () => {
    setDateSort((prevState) => (prevState === 'desc' ? 'asc' : 'desc'));
  };

  const addFilter = (filter: FiltersType) => {
    setFilters((prevState) => [...prevState].concat(filter));
  };

  const resetFilters = () => {
    setFilters([]);
  };

  useEffect(() => {
    fetch();
  }, [dateSort, filters]);

  return {
    data,
    dateSort,
    isLoading,
    filters,

    toggleDateSort,
    fetch,
    resetFilters,
    addFilter,
  };
};

export default useGameEvents;
